import { useEffect, useState } from "react";

export const useCountdown = (targetDate: string | null) => {
  const [countdown, setCountdown] = useState({
    days: "00",
    hours: "00",
    minutes: "00",
    seconds: "00",
  });
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    if (!targetDate) return;

    const target = new Date(targetDate).getTime();

    // Pisahkan ke dalam fungsi agar bisa dipanggil langsung tanpa menunggu 1 detik pertama
    const calculateTime = () => {
      const now = new Date().getTime();
      const distance = target - now;

      if (distance <= 0) {
        // Optimasi Prev State: Hanya update jika nilainya memang belum "00"
        setCountdown((prev) => {
          if (
            prev.days === "00" &&
            prev.hours === "00" &&
            prev.minutes === "00" &&
            prev.seconds === "00"
          ) {
            return prev; // Mengembalikan referensi lama, membatalkan re-render
          }
          return { days: "00", hours: "00", minutes: "00", seconds: "00" };
        });

        // Optimasi Prev State: Hanya update jika isReady belum true
        setIsReady((prev) => (prev === true ? prev : true));
        return true; // Indikator bahwa waktu sudah habis
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
      );
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      const pad = (num: number) => String(Math.max(0, num)).padStart(2, "0");

      const newDays = pad(days);
      const newHours = pad(hours);
      const newMinutes = pad(minutes);
      const newSeconds = pad(seconds);

      // Optimasi Prev State: Bandingkan nilai baru dengan yang lama
      setCountdown((prev) => {
        if (
          prev.days === newDays &&
          prev.hours === newHours &&
          prev.minutes === newMinutes &&
          prev.seconds === newSeconds
        ) {
          return prev; // Membatalkan re-render jika tidak ada perubahan
        }
        return {
          days: newDays,
          hours: newHours,
          minutes: newMinutes,
          seconds: newSeconds,
        };
      });

      setIsReady((prev) => (prev === false ? prev : false));
      return false; // Indikator waktu belum habis
    };

    // Jalankan sekali saat komponen dimuat (menghilangkan jeda/delay 1 detik)
    const isFinished = calculateTime();

    // Jika sudah habis dari awal, tidak perlu membuat interval
    if (isFinished) return;

    const interval = setInterval(() => {
      const finished = calculateTime();
      if (finished) {
        clearInterval(interval);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [targetDate]);

  return { countdown, isReady };
};
